module.exports = __webpack_public_path__ + "static/img/food-policy033.5e5ea11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food-policy033.png
// module id = xfvk
// module chunks = 1